export default {
    clientInbox: {
        subtitle:
            '受信箱の書類は、受信されてから１年間閲覧可能です。<0>現在本受信箱にアクセスできるユーザー</0>',
        title: '取引先受信箱',
        userListPopup: {
            edit: '編集',
            footer: 'ユーザの変更依頼は、{{ partnerName }}までご連絡ください。',
            heading: '現在アクセス可能なユーザー：',
        },
    },
    clientInboxItem: {
        bizpayPanel: {
            description:
                '法人や個人事業主なら、提携サービスを利用することで、銀行振込の請求書をカードでお支払いができます（※）。',
            disclaimer:
                '※ 提携サービスにてアカウント登録および審査が必要です。',
            linkText: '<0 className="mr-2"></0>ウェブサイトを見る', // The JA version needs this right margin
            title: '請求書カード払い',
        },
        cancelled: '差出人がこの書類を無効にしました。',
        infoPanel: {
            download: 'ダウンロード',
            title: '概要',
            view: '表示',
            zipExplanation:
                '当ファイルは、{{ partnerName }}からアップロードされたまま提供させていただきます。内容等に関する問い合わせはMakeLeapsからご案内いたしかねます。<0></0><0></0>なお、ウイルススキャンが行われていませんので、当ファイルや送付者に関して覚えがない場合は、ダウンロードせず無視してください。',
            zipTitle: '{{ partnerName }}からZIPファイルが送信されました。',
        },
        loginToMakeLeaps: {
            login: 'MakeLeapsユーザーの方はこちらから<0>ログイン</0>。',
            salesForce:
                'MakeLeaps for Salesforceユーザーのログインには未対応です。',
        },
        payPanel: {
            autoChargeEnabledMessage:
                'このカードは自動引き落とし用に設定され、今後取引先が請求した際に利用されます。',
            button: '支払う',
            errorMessages: {
                generic:
                    '決済システムでエラーが発生しました。しばらく経ってから再度お試しください。問題が継続するようでしたら、support@makeleaps.comまでご連絡ください。',
                timeout:
                    '現在、決済システムから応答がありません。しばらく経ってから再度お試しください。問題が継続するようでしたら、support@makeleaps.comまでご連絡ください。',
            },
            paid: '支払い済み',
            paymentTotal: 'お支払い額',
            successMessage: 'お支払が完了しました。誠にありがとうございます！',
            title: 'お支払い',
        },
        returnToClientInbox: '取引先受信箱に戻る',
    },
    clientInboxUsers: {
        cardEditSubtext: 'メールアドレスを1つ以上入力してください',
        cardTitle: '取引先受信箱',
        fieldLabel: '取引先受信箱ユーザー',
        fieldTooltip:
            '通知メールを受ける、かつ取引先受信箱へアクセスできるメールアドレス',
        formErrorEmailDuplicate: '1メールアドレスは一度のみ設定できます。',
        information:
            'ユーザーの変更依頼は、{{ partnerName }}までご連絡ください。',
        privacyAgree:
            'メイクリープス株式会社<0>プライバシー</0>ポリシーに同意します。',
        privacyAgreeRequired:
            'MakeLeaps株式会社のプライバシーポリシーに同意する必要があります。',
        privacyNotice:
            '提供された個人情報は本取引ポータルの契約者（{{ partnerName }}）と共同して利用することがあります。共同して利用する情報項目はメールアドレスに限ります。なお、これらの情報は<0>メイクリープス株式会社</0>の最高経営責任者が責任をもって管理します。',
        viewSubtitle:
            '{{ partnerName }}が運用する取引ポータルに適用される設定。運用企業の設定により、編集できる場合があります。',
        viewTitle: '設定',
        warningEnd:
            '本当にメールアドレス {{email}} を削除してよろしいでしょうか。',
        warningExplanation1:
            '本取引先受信箱の通知の受信や、アクセスができなくなる',
        warningExplanation2: '<0>即時に</0>本取引先受信箱のセッションが切れる',
        warningStart: 'メールアドレス {{email}} を削除すると、',
        warningSubmit: '削除してログアウト',
        warningTitle: 'ログイン中のユーザーを削除',
    },
    downloadDocumentModal: {
        cancel: 'キャンセル',
        download: '書類{{numberOfItems}}件のダウンロードを準備しています。',
        downloadBody:
            '選択された書類をZIPファイルに圧縮してからダウンロードが始まります。ダウンロード完了後、このメッセージが自動的に閉じます。',
        downloadLink: 'ダウンロード',
        error: 'エラーが発生しました。しばらく経ってから再度お試しください。',
        includesZipFile:
            '注意：ZIPファイルは、MakeLeaps契約企業によりアップロードされたまま提供されます。詳しくは<0>こちら</0>。',
    },
    edit: '編集',
    filters: {
        all: 'すべて',
        clear: '検索条件をリセット',
        documentStatus: 'ステータス',
        documentStatuses: {
            all: 'すべて',
            cancelled: 'キャンセル済み',
            inaccessible: '取り下げ済み',
            valid: '有効',
        },
        documentType: '種類',
        documentTypeTooltip:
            'MakeLeaps標準書類種類名（書類上の表記と一致しない場合があります）',
        pdf: 'PDF',
        receivedDate: '受信日',
        searchTerms: '検索',
        searchTermsTooltip: '検索対象：書類番号、案件名の列',
        zip: 'ZIP',
    },
    footer: {
        aboutMl: 'MakeLeapsについて',
        portalManual: '取引ポータルのマニュアル',
        poweredBy: 'Powered by',
    },
    home: {
        subtitle: '取引ポータル一覧',
    },
    inbox: {
        action: '操作',
        addressee: '宛先',
        addToSecureInbox: '受信箱に追加',
        addToSecureInboxTitle: 'MakeLeapsのセキュア受信箱に追加してください。',
        amountToPay: '今回御請求額',
        cancelled: '送信元よりキャンセル済み',
        company: '受領する会社',
        displayName: '書類',
        documentNumber: '書類',
        documentType: '種類',
        documentTypeTooltip:
            'MakeLeaps標準書類種類名（書類上の表記と一致しない場合があります）',
        download: 'ダウンロード',
        downloadSelection: '一括ダウンロード',
        downloadSelectionDisabledReason:
            'ダウンロードする書類が選択されていません。二通以上お選びください。',
        fileSize: 'ファイルサイズ',
        inaccessible: '送信元より取り下げ済み',
        jst: '日本時間',
        noDocuments:
            '表示できる書類がありません。最近書類を受信されていない、もしくは検索条件に該当する書類がありません。',
        paid: '支払い済み',
        pay: 'お支払い...',
        pdfPanelTitle:
            '{{ partnerName }}から{{ documentType }}が送信されました。',
        preview: 'プレビューなど...',
        projectName: '案件名',
        received: '受信日',
        receivedWithTime: '受信日時',
        return: '取引ポータル一覧へ',
        seeDetails: '詳細を見る',
        total: '合計金額',
        unsupportedDocument: 'この書類形式には対応していません。',
        view: '表示',
    },
    login: {
        closeTab: 'タブを閉じる',
        email: 'メールアドレス',
        faqAnswer1:
            '「取引ポータル by MakeLeaps」は、貴社と貴社の取引先であるMakeLeaps契約企業との情報共有ができる場所です。過去に受信した請求書などの書類や、各種ファイルの一覧をご確認いただけます。',
        faqAnswer2:
            'まずは<0>取引ポータルのマニュアル</0>をご確認ください。そちらでトラブル解決の方法を案内しています。<1></1>それでも解決できない場合、MakeLeaps契約企業である貴社の取引先まで連絡するようにお願いいたします。（MakeLeapsのサポート対応は、契約企業からのお問い合わせに限ります。直接弊社までご連絡いただいても対応できかねますので、あらかじめご了承ください。）',
        faqAnswer3:
            'MakeLeapsはクラウド型請求管理サービスです。取引先向けに、見積書や請求書など帳票の作成・送付ができます。<0></0><0></0>詳細は弊社の<1>ホームページ</1>をご覧ください。',
        faqAnswer4:
            'MakeLeaps契約企業が取引ポータルのユーザーとして登録したメールアドレスのみ、取引ポータルの利用が可能です。<0></0><0></0>当該メールアドレス宛にログインリンクを送信し、そのリンクをクリックすることで、ログインの認証がされます。<0></0><0></0>セキュリティに関して詳しくは<1>取引ポータルのマニュアル</1>をご確認ください。',
        faqQuestion1: '「取引ポータル by MakeLeaps」とは？',
        faqQuestion2:
            '使い方がわかりません。／エラーの解決方法がわかりません。',
        faqQuestion3: 'MakeLeapsとは？',
        faqQuestion4: '取引ポータルのセキュリティはどう担保されていますか。',
        faqTitle: 'よくあるご質問',
        linkExpirationWarning: 'ログインリンクは1時間有効です。',
        login: 'Log in using a different email address',
        partnerSubtitle:
            '<0>{{ partnerName }}</0>との取引先受信箱に書類が届きました。ログインリンクの送信を行ってご確認ください。',
        portalLink: '取引ポータルのマニュアル',
        rememberMe: '次回から入力を省略',
        submit: 'ログインリンクを送信',
        subtitle:
            '取引ポータルにアクセスするには、取引に利用されているメールアドレスを入力してください。',
        successMessage:
            'MakeLeaps契約企業が{{email}}向けに取引ポータルを公開していれば、まもなくログインリンクが送信されます。',
        successTitle: '受信箱をご確認ください',
        title: '取引ポータル by MakeLeaps へようこそ',
        troubleshootingDomain:
            'makeleaps.com が受信可能のドメインとして登録されていることをご確認ください。',
        troubleshootingEmail:
            'メールアドレスを正しく入力したことをご確認ください。',
        troubleshootingPersonalEmail:
            '取引の連絡用にメールアドレスや取引ポータルの設定が正しくされていること、貴社の取引先までご確認ください。',
        troubleshootingSpam:
            '迷惑メールボックスに振り分けられていないかをご確認ください。',
        troubleshootingTitle: 'ログインリンクを受信できなかった場合',
        tryAgain: '戻る',
    },
    logout: 'ログアウト',
    notifications: {
        badLinkToken:
            '有効期限切れなどの理由により、このログインリンクが無効です。以下より再度ログインリンクの送信を行なってください。',
        cookieNotSet:
            'MakeLeapsのCookieがブロックされています。Cookieを許可するように設定を変更してから、再度ログインリンクの送信を行ってください。',
        expiredSessionToken:
            'セッションが切れました。以下より再度ログインリンクの送信を行ってください。',
        invalidSessionToken:
            'セッションが確認できませんでした。以下より再度ログインリンクの送信を行ってください。',
        loggedOut:
            'ログアウトが完了しました。取引ポータルのご利用ありがとうございました。',
        missingSessionToken:
            'アクセスしようとしたウェブページを閲覧するには、ログインが必要です。以下よりログインリンクの送信を行ってください。',
        portalNotAvailable:
            'アクセスしようとしたURLが無効、または現在ログイン中のメールアドレスでは閲覧できないURLです。URLが正しいことをご確認ください。',
    },
    personalInbox: {
        subtitle: '{{email}}へ送信されたすべての書類を確認できます。',
        title: 'マイ受信箱',
    },
    resend: {
        error: 'お手数ですが、再度お試しください。',
        init: 'ログインリンクを再送信',
        requested: '再送信中...',
        success: 'リンクが再送信されました',
    },
    sessionCustomExpiration: '{{ sessionMinutes }}分',
    sessionTimer: {
        expired: 'セッションの有効期限が切れました',
        expiry: 'セッションは{{hours}}時間{{minutes}}分後に切れます',
        expiryMinutesOnly: 'セッションは{{minutes}}分後に切れます',
        expirySecondsOnly: 'セッションは{{seconds}}秒後に切れます',
    },
    signOffDocumentModal: {
        cancel: 'キャンセル',
        cancelled: '差出人がこの書類を無効にしました。',
        confirmation: {
            accepted: '検収を行っていただき、ありがとうございました。',
            header: '検収完了を通知する',
            info: '検収を行った方のお名前をご入力ください。検収完了の通知が送信されます。',
            ownDocument: '自社の書類は検収いただけません。',
            signerInput: '検収者名',
            signOff: '検収完了を通知',
            title: '検収',
        },
        noteInput: 'メッセージ',
        order: {
            accepted: 'ご注文を受け付けました。ありがとうございます。',
            header: 'この書類を発注する',
            info: 'この書類を発注するには発注者名をご入力ください。発注を確定されると取引先に通知が送信されます。',
            ownDocument: '自社の書類は発注いただけません。',
            signerInput: '発注者名',
            signOff: '発注',
            title: '発注',
        },
        total: '合計金額',
    },
};
